import React,{ ReactNode } from 'react';
import arrowIcon from '@ingka/ssr-icon/paths/arrow-right';
import {
  ArrowButton,
  ButtonWrapper,
  Children,
  Content,
  ImageWrapper,
  Label,
  Eventtitle,
  Wrapper,
  StyledLink,
  SlideShowWrapper,
} from './style';
import Badges, { Colors } from './Badges';
import AspectRatioImage from '../AspectRatioImage';
import ConditionalRender from '../ConditionalRender';

type PropsType = {
  title: string;
  label: string;
  aspectRatioImageProps: {
    src: string;
    srcSet: string;
    ratio: 'square' | 'standard' | 'wide' | 'portrait';
    loading?: string;
  };
  children: ReactNode;
  buttonText: string;
  badges?: [string, Colors][];
  eventPath: string;
  inSlideShow: boolean;
  storeName?: string;
};

const Card = (props: PropsType) => {
  const WrapperElement = props.inSlideShow ? SlideShowWrapper : Wrapper;
  return (
    <WrapperElement>
      <Content>
        {/* Make title a link */}
        <Eventtitle alt-text={props.title}>
          <StyledLink to={props.eventPath}>{props.title}</StyledLink>
        </Eventtitle>
        <ConditionalRender predicate={Boolean(props.storeName)}>
          <p> {props.storeName} </p>
        </ConditionalRender>
        <Label>
          {props.label}  
        </Label>
        <Children>
  {React.Children.map(props.children, (child, idx) => (
    <StyledLink key={idx} to={props.eventPath}>
      {child}
    </StyledLink>
  ))}
</Children>

        <ButtonWrapper>
          <ArrowButton
            type="secondary"
            ssrIcon={arrowIcon}
            iconOnly={true}
            text={props.buttonText}
          />
        </ButtonWrapper>
      </Content>
      <ImageWrapper>
        <Badges badges={props.badges || []} />
        {/* Make image a link */}
        <StyledLink to={props.eventPath}>
          <AspectRatioImage
            src={props.aspectRatioImageProps.src}
            srcSet={props.aspectRatioImageProps.srcSet}
            ratio={props.aspectRatioImageProps.ratio}
            loading={props.aspectRatioImageProps.loading}
            alt=""
          />
        </StyledLink>
      </ImageWrapper>
    </WrapperElement>
  );
};

export default Card;